<style lang="scss" scoped>
.header {
	background: white;
	height: 80px;
	border-bottom: 1px solid #e5eaee;

	h1 {
		cursor: pointer;
	}

	* {
		font-family: proxima-soft;
	}

	&__logout {
		@include flex-center;

		&__name {
			margin-right: 20px;
		}
	}

	&__pending {
		background: red;
		color: white;
		font-size: 11px;
		display: block;
		position: absolute;
		top: 0;
		right: -20px;
		width: 15px !important;
		height: 15px !important;
		z-index: 4;
		line-height: 15px !important;
		border-radius: 100%;
		text-align: center;
	}

	&__logo {
		background: url(/static/img/brand/Wonde-Icon-Colour.svg);
		text-indent: -9999px;
		background-repeat: no-repeat;
		height: 40px;
		width: 33.33px;
		float: left;
		margin-top: 20px;
		position: relative;
	}

	&__organisation {
		font-weight: 800;
		margin-left: 80px;
		padding-top: 23px;
		color: #4b5558;
		font-size: 19px;
	}

	&__navigation {
		margin-left: 100px;

		.count {
			position: absolute;
			top: 0;
			height: auto;
			line-height: 20px;
			height: 20px;
			font-size: 11px;
			color: white;
			border-radius: 100%;
			width: 20px;
			text-align: center;
			right: -23px;
			position: absolute;
			top: -12px;
			background: #dc2c34;
			height: auto;
		}

		a,
		span {
			text-decoration: none;
			color: #86999c;
			font-weight: 600;
			cursor: pointer;

			&.router-link-exact-active {
				color: darken(#4b5658, 10);
			}

			&:hover {
				color: darken(#4b5658, 10);
			}
		}

		span.header__pending {
			color: white;
		}

		.disabled {
			cursor: not-allowed;
		}

		a {
			position: relative;
		}

		li {
			display: inline-block;
			margin-right: 30px;
		}

		li.right {
			float: right;
		}

		* {
			height: 80px;
			line-height: 80px;
		}
	}

	&__logout {
		cursor: pointer;
		position: relative;
		text-align: right;
		padding-right: 24px;
		height: 80px;
		line-height: 80px;
		display: block;
		font-weight: 800;
		font-size: 17px;
		color: #343b3c;
	}

	&__dropdown {
		float: right;
		// display: none;
		.window {
			cursor: pointer;
			position: relative;
			padding-top: 14px;
			text-align: right;
			padding-right: 24px;
			height: 54px;
		}

		.icon {
			position: relative;
			top: 10px;
		}

		.name {
			font-weight: 600;
			color: #4b5658;
			margin-bottom: -1px;
		}

		.school {
			font-size: 14px;
			color: #6e7e81;
			font-weight: 500;
			max-width: 25ch;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}

		.arrow {
			top: 56%;
			right: 0;
			position: absolute;
		}

		.login {
			height: 80px;
			display: block;
			line-height: 80px;
			font-weight: 600;
			color: #4b5557;

			svg {
				margin-right: 10px;
				position: relative;
				top: 6px;
			}
		}
	}
}

.hamburger {
	cursor: pointer;

	span {
		display: block;
		height: 4px;
		width: 35px;
		background: black;
		margin-top: 6px;
		margin-bottom: 6px;
	}
}

.progress-bar {
	display: inline-block;
	height: 13px;
	width: 100px;
	margin-left: 20px;
	background: #cdcfd2;
	border-radius: 10px;
	position: relative;
	top: 2px;
	margin-right: 60px;

	&__progress {
		background: #307fe2;
		height: 13px;
		border-radius: 10px;
	}
}

.getting-started {
	a {
		color: #343b3c;
	}
}
</style>

<template lang="pug">
#header(v-if="User")
	header.header
		notifications
		.container
			.header__dropdown(v-if="User")
				.window(v-if="!User.is_student", @click="toggleDropdown", v-on-clickaway="hideDropdown")
					.name(data-private) {{ User.display_name }}
					.school {{ User.is_organisation_admin ? 'Organisation' : User.School.name }}
					.arrow.icon.--dropdown
					ul.dropdown(v-if="showDropdown")
						li.dropdown__item
							router-link.dropdown__link(:to="{ name: 'account' }") Account settings
								small Manage settings such as notification preferences
						li.dropdown__item(v-if="User.is_teacher || User.is_free_teacher")
							router-link.dropdown__link(:to="{ name: 'account.saved-passwords' }") Manage passwords
								small Manage your Single Sign-On passwords
						li.dropdown__item(v-if="User.is_free_teacher")
							router-link.dropdown__link(:to="{ name: 'teacher-billing' }") Billing
								small Manage your Wonde subscription
						li.dropdown__item(v-if="User.is_organisation_admin")
							router-link.dropdown__link(:to="{ name: 'organisation.users' }") User management
								small Create and manage your team
						//- li.dropdown__item(v-if="User.is_admin || User.is_teacher || User.is_organisation_admin")
							a.dropdown__link(@click="$refs.userPicker.toggle()") Account switch
							    small Switch between multiple accounts
						template(v-if="User.is_admin && !User.is_test")
							li.dropdown__item(v-if="hasThirdPartyTokens")
								router-link.dropdown__link(:to="{ name: 'third-party-tokens' }") Third party tokens
									small Manage your school's third party tokens
						li.dropdown__item
							a.dropdown__link(@click="logout") Logout
								small Securely logout of Wonde
				.header__logout(v-else="")
					.header__logout__name(data-private) {{ User.display_name }}
					el-button(type="danger", @click="logout()", size="small") Logout
			.header__dropdown(v-if="User === false")
				a.login(href="http://edu.wonde.com/login")
					svg.feather.feather-user(
						xmlns="http://www.w3.org/2000/svg",
						width="24",
						height="24",
						viewbox="0 0 24 24",
						fill="none",
						stroke="currentColor",
						stroke-width="2",
						stroke-linecap="round",
						stroke-linejoin="round",
						color="#384047"
					)
						path(d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2")
						circle(cx="12", cy="7", r="4")
					|
					| Login to Wonde
			router-link.header__logo(tag="h1", :to="logoDestination") Wonde
			ul.header__navigation(tag="div", v-if="User.is_organisation_admin")
				li
					router-link(:to="logoDestination") Dashboard
				li
					router-link(:to="{ name: 'organisation.applications' }") Applications
				li
					router-link(:to="activityDestination") Activity
			ul.header__navigation(v-if="User && !User.is_organisation_admin")
				li(v-if="User.is_admin && User.is_beta")
					router-link(:to="{ name: 'store' }") {{ trans('header.b_store') }}
				li(v-if="User.is_contact")
					router-link(:to="{ name: 'accounts' }") {{ trans('header.b_accounts') }}
				li(v-if="!User.is_free_teacher && !User.is_free_student")
					router-link.apps(:to="{ name: 'dashboard' }") Dashboard
						el-tooltip
							div(slot="content")
								template(v-if="pendingAppCount === 1") There is {{ pendingAppCount }} pending application
								template(v-else) There are {{ pendingAppCount }} pending applications
							span.header__pending(v-if="pendingAppCount") {{ pendingAppCount }}
				li(v-if="User.is_free_teacher || User.is_free_student")
					router-link(:to="{ name: 'classroom.show', params: { class: User.Classrooms[0].id } }")
						template(v-if="User.is_free_teacher") Applications
						template(v-else) Classroom
				li(v-if="User.is_free_teacher")
					router-link(:to="{ name: 'classroom.students', params: { class: User.Classrooms[0].id } }") Students
				li(v-if="User.is_free_teacher")
					router-link(:to="{ name: 'classroom.settings', params: { class: User.Classrooms[0].id } }") Settings
				li(v-if="User.is_admin && !User.is_test && !User.School.sso_enabled && User.School.shard_id !== 2")
					router-link(:to="{ name: 'singleSignOn' }") {{ trans('header.b_sso_opt_in') }}
				li(v-if="User.is_admin && !User.is_test")
					router-link(:to="{ name: 'settings' }") Manage settings
				li(v-if="User.is_admin")
					router-link(:to="{ query: { notifications: 'true' } }") Notifications
				li(v-if="User.is_teacher && !User.is_admin")
					router-link(:to="{ name: 'settings.directory' }") Directory
				li(v-if="(User.is_free_teacher || User.is_teacher || User.is_admin || User.is_organisation_admin) && User.School.shard_id !== 2")
					a.apps(:href="discoverUrl") Discover
				li.right.getting-started(v-if="((User.is_admin && User.School.sso_enabled) || User.is_free_teacher) && gettingStartedPercent !== 100")
					router-link(:to="{ name: 'account.progress' }") Getting started
						.progress-bar
							.progress-bar__progress(:style="`width:${gettingStartedPercent}%`")
	//- user-picker(ref="userPicker")
	session-expire-notice(:user="User")
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import gql from "graphql-tag";
import SessionExpireNotice from "./SessionExpireNotice";
import Notifications from "./Notifications";
import { isChromeExtensionInstalled } from "@/utils/common";
import _ from "lodash";

export default {
	components: {
		Notifications,
		SessionExpireNotice,
		// UserPicker
	},
	mixins: [clickaway],
	data() {
		return {
			dropdownVisible: false,
			User: null,
			Notifications: null,
			showDropdown: false,
			classroom_uuid: null,
		};
	},
	computed: {
		discoverUrl() {
			return process.env.DISCOVER_URL;
		},
		pendingAppCount() {
			if (this.User && this.User.is_admin) {
				return _.filter(this.User.Companies, { approved: false, declined: false }).length;
			} else {
				return 0;
			}
		},
		logoDestination() {
			if (this.User && this.User.is_organisation_admin) {
				return { name: "organisation" };
			}
			if (this.$route.meta.public) {
				return { name: "store" };
			} else {
				return { name: "dashboard" };
			}
		},
		activityDestination() {
			if (this.User && this.User.is_organisation_admin) {
				return { name: "organisation.activity" };
			}
			if (this.$route.meta.public) {
				return { name: "store" };
			} else {
				return { name: "dashboard" };
			}
		},
		hasThirdPartyTokens() {
			return this.User.School.mis_identity === "scholarpackrest";
		},
		gettingStartedPercent() {
			const notificationFilterLength = (types) => this.User.Notifications.filter((notification) => types.includes(notification.type)).length;
			const segments = [];

			if (this.User.is_admin) {
				if (!this.Companies) {
					return 100;
				}

				segments.push(!!this.Companies.length);
				segments.push(!!notificationFilterLength(["student_credentials", "saved_password_credentials"]));
				segments.push(!!notificationFilterLength(["employee_credentials"]));
				segments.push(!!this.User.chrome_extension_agreed);
			}

			if (this.User.is_free_teacher) {
				if (!this.Classroom || !this.ClassroomCompanies) {
					return 100;
				}

				segments.push(isChromeExtensionInstalled());
				segments.push(!!this.Classroom.Students.length);
				segments.push(!!this.ClassroomCompanies.length);
				segments.push(!!this.User.qr_code);
			}

			return (segments.filter((value) => value).length / segments.length) * 100;
		},
	},
	apollo: {
		// ContextShardUser: {
		// 	client: "next",
		// 	query: gql`
		// 		query NextContextShardUser {
		// 			ContextShardUser {
		// 				id
		// 				firstName
		// 				lastName
		// 			}
		// 		}
		// 	`,
		// 	result({ data }) {
		// 		console.log("ContextShardUser", data);

		// 		if (!data) {
		// 			this.$router.push({ name: "logout" });
		// 		}
		// 	},
		// 	skip() {
		// 		return localStorage.getItem("wonde-user-type") === "org-admin";
		// 	},
		// },
		ContextUser: {
			client: "next",
			query: gql`
				query NextContextUser {
					ContextUser {
						id
						firstName
						lastName
					}
				}
			`,
			result({ data }) {
				if (!data) {
					this.$router.push({ name: "logout" });
				}
			},
			skip() {
				return localStorage.getItem("wonde-user-type") !== "org-admin";
			},
		},
		User: {
			query: gql`
				query User {
					User {
						id
						is_student
						display_name
						is_admin
						is_beta
						is_test
						is_student
						is_teacher
						is_free_teacher
						is_free_student
						is_contact
						is_organisation_admin
						session_expire
						qr_code
						chrome_extension_agreed
						Companies {
							id
							approved
							declined
							Associations {
								uuid
								classroom_uuid
							}
						}
						Classrooms {
							id
						}
						School {
							id
							name
							sso_enabled
							mis_identity
							shard_id
						}
						LinkedPeople {
							id
						}
						Notifications {
							id
							url
							type
						}
					}
				}
			`,
			result({ data }) {
				if (data && data.User.is_free_teacher) {
					this.classroom_uuid = data.User.Classrooms[0].id;
				}

				// if(data.User.is_admin && data.User.School.id  === 'A1473395501') {
				// 	this.$router.push({ path: 'school-disabled' })
				// }
			},
			error() {
				const self = this;

				setTimeout(function () {
					self.$apollo.queries.User.refetch();
				}, 2000);
			},
		},
		Classroom: {
			query: gql`
				query Classroom($uuid: String!) {
					Classroom(uuid: $uuid) {
						id
						name
						Students {
							userId
							name
						}
					}
				}
			`,
			variables() {
				return {
					uuid: this.classroom_uuid,
				};
			},
			skip() {
				return this.classroom_uuid === null;
			},
		},
		ClassroomCompanies: {
			query: gql`
				query ClassroomCompanies($uuid: String!) {
					User {
						id
						Companies(classroom_uuid: $uuid) {
							id
						}
					}
				}
			`,
			variables() {
				return {
					uuid: this.classroom_uuid,
				};
			},
			update: (r) => r.User.Companies,
			skip() {
				return this.classroom_uuid === null;
			},
		},
		Companies: {
			query: gql`
				query Companies {
					Companies {
						id
					}
				}
			`,
		},
	},
	methods: {
		hideDropdown() {
			this.showDropdown = false;
		},
		toggleDropdown() {
			this.showDropdown = !this.showDropdown;
		},
		logout() {
			this.$router.push({ name: "logout" });
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/global/Header.vue